import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import EcoSystemIntroCard from "./EcoSystemIntroCard"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokEcoSystemIntroCard = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.EcoSystemIntroCard>) => {
  return (
    <EcoSystemIntroCard
      backgroundColor={blok.backgroundColor}
      titleText={blok.titleText}
      descriptionText={blok.descriptionText}
      iconUrl={blok.icon?.filename}
      iconAlt={blok.icon?.alt}
      size={blok.size}
      buttonText={blok.ctaText || ""}
      buttonLink={storyblokLinkToYocoLink(blok.ctaLink) || undefined}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokEcoSystemIntroCard
